import { configureStore } from "@reduxjs/toolkit";
import { api } from "./services/index.api";
import { UserSlice } from "./features/user";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [UserSlice.reducerPath]: UserSlice.reducer,
  },
  middleware: (gDM) => gDM().concat(api.middleware),
});

export type RootState = Omit<ReturnType<typeof store.getState>, "api">;
